@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Dokumentacja</div>

    <!-- a readout of the BOM: nothing is created from here, files are added on the element (0125) -->
    <div class="header-toolbar">
      <input class="search-input" type="text" placeholder="Szukaj po nazwie pliku…" #search
        (input)="onSearchInput(search.value)">

      <button class="btn" #typeFilterTrigger>Typ: {{ typeFilterLabel(state.typeFilter) }}</button>
    </div>
  </div>

  <dropdown [searchFunc]="searchTypeOptions" [searchFormatter]="formatTypeOption" [trigger]="typeFilterTrigger"
    [minSearchLength]="0" [debounceMs]="0" header="TYP" (itemSelected)="onTypeSelected($event)"></dropdown>

  <!-- the panel, the count line and the table with its header row are the layout; the rows and the count are
       the data, drawn as shadows until it lands (0128) -->
  <div class="list-panel">
    <div class="list-count">
      @if (state.loading) {
        <span class="shadow"></span>
      } @else if (state.items) {
        {{ fileCountLabel(state.totalCount) }}
      }
    </div>

    <div class="list-table" #listTable>
      <div class="list-row list-row-header document-row">
        <div class="list-cell"></div>
        <div class="list-cell">Nazwa pliku</div>
        <div class="list-cell">Typ</div>
        <div class="list-cell">Element BOM</div>
        <div class="list-cell">Numer</div>
        <div class="list-cell list-cell-right">Rozmiar</div>
        <div class="list-cell">Dodano</div>
      </div>

      @if (state.loading) {
        <!-- five rows of the page's own row, at its height: the 40px slot a photo or a kind's icon takes holds it (0128) -->
        @for (row of shadowRows; track row) {
          <div class="list-row list-row-shadow document-row">
            <div class="shadow shadow-photo-card"></div>
            <div class="list-cell"><span class="shadow shadow-long"></span></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
            <div class="list-cell"><span class="shadow"></span></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
            <div class="list-cell list-cell-right"><span class="shadow shadow-short"></span></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
          </div>
        }
      } @else if (state.items) {
        <!-- a div, not an anchor: the row has two destinations, the file and the element -->
        @for (attachment of state.items; track attachment.id) {
          @let kind = kindOf(attachment);

          <div class="list-row document-row">
            <!-- the picture itself for an image, the kind's icon otherwise, in one 40px slot -->
            @switch (kind) {
              @case ('image') {
                <item-photo size="card" [attachmentId]="attachment.id" [label]="attachment.fileName"></item-photo>
              }
              @case ('pdf') {
                <div class="document-row-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                  </svg>
                </div>
              }
              @case ('spreadsheet') {
                <div class="document-row-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                  </svg>
                </div>
              }
              @case ('text') {
                <div class="document-row-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                  </svg>
                </div>
              }
            }

            <div class="list-cell document-row-name">
              <a class="document-row-file" [href]="contentUrl(attachment)" target="_blank" rel="noopener" [title]="attachment.fileName">{{ attachment.fileName }}</a>
              @if (attachment.isPrimaryPhoto) {
                <!-- the card's filled star: a mark, not an action — the main photo is set on the element -->
                <span class="document-row-primary" title="Zdjęcie główne">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                  </svg>
                </span>
              }
            </div>
            <div class="list-cell document-row-kind">{{ kindLabels[kind] }}</div>
            <a class="list-cell document-row-item" [routerLink]="['/bom', attachment.bomItemId]" [title]="attachment.bomItemName">{{ attachment.bomItemName }}</a>
            <div class="list-cell document-row-part-number text-mono" [title]="attachment.bomItemPartNumber ?? ''">{{ attachment.bomItemPartNumber ?? '—' }}</div>
            <div class="list-cell list-cell-right document-row-size text-mono">{{ formatSize(attachment.sizeBytes) }}</div>
            <div class="list-cell document-row-created text-mono">{{ formatCreatedAt(attachment) }}</div>
          </div>
        } @empty {
          <!-- A tenant with no files at all gets the invitation regardless of search/filter -->
          @if (state.catalogEmpty) {
            <div class="list-empty">Brak załączników — dodaj pliki do elementów BOM.</div>
          } @else if (state.search) {
            <div class="list-empty">Brak wyników dla „{{ state.search }}”</div>
          } @else {
            <div class="list-empty">Brak plików tego typu.</div>
          }
        }
      }
    </div>

    <!-- the pager needs the answer: it lands under the table and moves nothing above it -->
    @if (!state.loading && state.totalCount > pageSize) {
      @let lastPage = pageCount(state);

      <!-- Real links (0092): open in a new tab and copy link work on a page number too -->
      <div class="pager">
        @if (state.page === 1) {
          <button class="btn btn-small" disabled>‹</button>
        } @else {
          <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(state.page - 1)" queryParamsHandling="merge" [replaceUrl]="true">‹</a>
        }

        @for (entry of pagerPages(state); track $index) {
          @if (entry === '…') {
            <span class="pager-gap">…</span>
          } @else if (entry === state.page) {
            <span class="btn btn-small active" aria-current="page">{{ entry }}</span>
          } @else {
            <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(entry)" queryParamsHandling="merge" [replaceUrl]="true">{{ entry }}</a>
          }
        }

        @if (state.page >= lastPage) {
          <button class="btn btn-small" disabled>›</button>
        } @else {
          <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(state.page + 1)" queryParamsHandling="merge" [replaceUrl]="true">›</a>
        }
      </div>
    }
  </div>
}
